import apiClient from './api/apiClient';

export interface BasicUiData {
  id: number;
  favicon_url: string;
  header_logo_url: string;
  web_name: string;
  admin_profile_image_url: string;
}

export interface BasicUiResponse {
  code: number;
  status: string;
  message: string;
  data: BasicUiData;
}

export interface Banner {
  id: number;
  title: string;
  text: string;
  image_url: string;
  font_color_hex_code: string;
}

export interface BannerResponse {
  code: number;
  status: string;
  message: string;
  data: Banner[];
}

export const basicUiApi = {
  // 기본 UI 설정 조회
  getBasicUi: async (): Promise<BasicUiData | null> => {
    try {
      const response = await apiClient.get<BasicUiResponse>('/api/admin/ui/basic');
      return response.data.data;
    } catch (error: any) {
      // 404 에러는 무시하고 null 반환 (기본 UI 설정이 없는 경우)
      if (error.response?.status === 404) {
        /// console.warn('기본 UI 설정을 찾을 수 없습니다. 기본값을 사용합니다.');
        return null;
      }
      // 다른 에러는 다시 throw
      throw error;
    }
  },

  // 홈 배너 목록 조회
  getBanners: async (): Promise<Banner[]> => {
    try {
      const response = await apiClient.get<BannerResponse>('/api/ui/home/banners/list');
      return response.data.data || [];
    } catch (error: any) {
      // 404 에러는 무시하고 빈 배열 반환 (배너가 없는 경우)
      if (error.response?.status === 404) {
        /// console.warn('배너를 찾을 수 없습니다.');
        return [];
      }
      // 다른 에러는 다시 throw
      throw error;
    }
  }
};
